/* eslint camelcase: 0 */
import moment from 'moment'
import { Media } from '@/infrastructure/network/Upstream/schema'
import { IMediaProps, EmptyMediaPropsFactory } from '@/entities/Upstream/Media'

export const toMediaProps = (props: Media | null | undefined): IMediaProps => {
  if (!props) {
    return EmptyMediaPropsFactory()
  }

  const { id, name, is_directory, created_at, updated_at } = props
  const properties = typeof props.properties === 'string' ? JSON.parse(props.properties).properties : props.properties

  return {
    id,
    uploadId: 0,
    name,
    isDirectory: !!is_directory,
    properties,
    progress: 0,
    total: 0,
    createdAt: created_at ? moment(created_at).format('YYYY-MM-DD HH:mm:ss') : null,
    updatedAt: updated_at ? moment(updated_at).format('YYYY-MM-DD HH:mm:ss') : null
  }
}
